import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useAdminAuth } from "@/lib/adminAuth";
import { extractErrorAr } from "@/lib/adminApi";
import Icon from "@/components/Icon";

export default function AdminLogin() {
  const { user, login, loading } = useAdminAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      toast.error("يرجى تعبئة جميع الحقول.");
      return;
    }
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      toast.success("تم تسجيل الدخول بنجاح.");
      nav("/admin");
    } catch (err) {
      toast.error(extractErrorAr(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen aman-hero flex items-center justify-center px-6 relative overflow-hidden"
      dir="rtl"
      data-testid="admin-login-page"
    >
      <div className="aman-glow-orb -top-24 -end-24" aria-hidden="true" />
      <div className="aman-glow-orb -bottom-32 -start-16 opacity-70" aria-hidden="true" />

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#00E5FF] to-[#00b8cc] flex items-center justify-center shadow-[0_0_30px_rgba(0,229,255,0.4)]">
            <Icon name="shield-check" className="text-[#0A1628]" size={28} strokeWidth={2.2} />
          </div>
          <h1 className="font-heading mt-4 text-3xl font-bold text-white">لوحة التحكم</h1>
          <p className="text-slate-400 text-sm mt-1">أدخل بياناتك للدخول إلى لوحة الإدارة</p>
        </div>

        <form onSubmit={submit} className="space-y-4 bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-3xl p-8" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">اسم المستخدم</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              className="w-full rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-slate-500 px-4 py-3 focus:outline-none focus:border-[#00E5FF] focus:ring-4 focus:ring-cyan-500/20 transition-colors"
              data-testid="admin-login-username"
              autoComplete="username"
              dir="ltr"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">كلمة المرور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••••••"
              className="w-full rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-slate-500 px-4 py-3 focus:outline-none focus:border-[#00E5FF] focus:ring-4 focus:ring-cyan-500/20 transition-colors"
              data-testid="admin-login-password"
              autoComplete="current-password"
              dir="ltr"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="aman-btn-primary w-full justify-center text-base disabled:opacity-60 disabled:cursor-not-allowed"
            data-testid="admin-login-submit"
          >
            {submitting ? "جارٍ الدخول..." : (<><Icon name="shield-check" size={18} strokeWidth={2} /> تسجيل الدخول</>)}
          </button>
        </form>

        <p className="text-center text-slate-500 text-xs mt-6">
          محمي بواسطة JWT — يمكن للمسؤول فقط الوصول
        </p>
      </div>
    </div>
  );
}
